import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

// Only bundle English (primary language) - others lazy loaded
import enCommon from './locales/en/common.json'
import enHome from './locales/en/home.json'
import enAiAgentBooks from './locales/en/aiAgentBooks.json'
import enChangelog from './locales/en/changelog.json'
import enToc from './locales/en/toc.json'
import enAiCostTrends from './locales/en/aiCostTrends.json'
import enPreview from './locales/en/preview.json'

export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
] as const

export type LanguageCode = (typeof supportedLanguages)[number]['code']

// English bundled in JS, other languages fetched on demand
const resources = {
  en: {
    common: enCommon,
    home: enHome,
    aiAgentBooks: enAiAgentBooks,
    changelog: enChangelog,
    toc: enToc,
    aiCostTrends: enAiCostTrends,
    preview: enPreview,
  },
}

// English is bundled, so SSR has everything it needs synchronously. The
// language detector reads localStorage/navigator and the http backend fetches
// over the network — neither exists while prerendering, so they are attached
// in the browser only.
const isBrowser = typeof window !== "undefined";

if (isBrowser) {
  i18n.use(HttpBackend).use(LanguageDetector);
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: supportedLanguages.map(lang => lang.code),
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'home', 'aiAgentBooks', 'changelog', 'toc', 'aiCostTrends', 'preview'],

    // Allow partial bundled languages (English bundled, others lazy loaded)
    partialBundledLanguages: true,

    // Lazy load non-English translations from public/locales/
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: true, // Enable Suspense for loading states
    },
  })

export default i18n
